import React, { ChangeEvent, FC, useContext, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  FormHelperText,
  Link,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'src/store';
import { login } from 'src/Areas/Genericos/GE/slices/account';
import { DoisFatoresContext } from 'src/Areas/Genericos/GE/contexts/DoisFatoresContext';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';
import { useSettings } from '@cigam/template/dist/hooks/useSettings';
import { numberRegex } from 'src/Areas/Genericos/GE/global/constants/regex';

const CodigoVerificacao: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { settings } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const { historyNavigation } = useSelector(state => state);
  const { username, password } = useContext(DoisFatoresContext);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [codigoVerificacao, setCodigoVerificacao] = useState('');
  const userStorage = localStorage.getItem('user');
  const userData = userStorage ? JSON.parse(userStorage) : '';
  const portalAtivo = settings.activePortals[0];

  const handleReenviar = async () => {
    setErro('');
    setCodigoVerificacao('');
    try {
      await dispatch(login(username, password, portalAtivo));
      enqueueSnackbar('Código de verificação enviado.', {
        variant: 'success',
      });
    } catch (error) {
      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);
      if (message === 'E-mail enviado.') {
        enqueueSnackbar('Código de verificação enviado.', {
          variant: 'success',
        });
      } else {
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '' || numberRegex.test(event.target.value)) {
      setCodigoVerificacao(event.target.value);
    }
    setErro('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await dispatch(login(username, password, portalAtivo, codigoVerificacao));
      history.push(historyNavigation.pathname);
      setLoading(false);
    } catch {
      setErro('Código de verificação inválido.');
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" color="textPrimary">
        Autenticação em Duas Etapas
      </Typography>
      <Typography variant="body1" color="textPrimary" mt={2}>
        Um e-mail com o código de verificação foi enviado para{' '}
        <u style={{ color: '#039BE5' }}>{userData.EmailUsuario}</u>.
      </Typography>
      <Tooltip title="Caso não esteja na caixa de entrada, verifique sua caixa de spam.">
        <TextField
          sx={{ marginTop: 4, marginBottom: 4 }}
          fullWidth
          autoFocus
          label="Inserir o código de verificação"
          margin="normal"
          name="codigoVerificacao"
          type="text"
          onChange={handleChange}
          value={codigoVerificacao}
          onKeyDown={event => {
            if (event.key === 'Enter') handleSubmit();
          }}
          InputProps={{
            inputProps: {
              style: { textAlign: 'center' },
              maxLength: 6,
            },
          }}
        />
      </Tooltip>
      <Link
        sx={{ cursor: 'pointer', marginTop: 2 }}
        underline="none"
        color="inherit"
        variant="body1"
        onClick={handleReenviar}
      >
        Reenviar
      </Link>
      <LoadingButton
        sx={{ marginTop: 4 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        onClick={handleSubmit}
      >
        Confirmar
      </LoadingButton>
      {erro && (
        <Box mt={2}>
          <FormHelperText error>{erro}</FormHelperText>
        </Box>
      )}
    </Box>
  );
};
export default CodigoVerificacao;
